module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cell"
  }, [_vm._t("default", [_vm._v(_vm._s(_vm.title))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3015572b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table/table-column.vue
// module id = 357
// module chunks = 0